import React from 'react';
export function HeroSection() {
  return <section className="relative pt-16 pb-0 md:pt-28 overflow-hidden" style={{
    backgroundColor: '#1F1A17'
  }} data-id="element-32">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-33" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-34">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex items-center gap-2 px-5 py-2 rounded-full bg-gray-900 border border-gray-800 text-emerald-500 text-sm font-bold tracking-wider mb-8" data-id="element-35">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-36" />
          NEXO RECURSOS™
        </div>

        {/* Headline */}
        <h1 className="animate-fade-in-up delay-100 text-4xl sm:text-5xl md:text-7xl font-extrabold text-white leading-[1.08] tracking-tight mb-6" data-id="element-37">
          Todo lo que necesita tu PyME para ordenarse.
          <br data-id="element-38" />
          <span className="text-emerald-500" data-id="element-39">Listo desde hoy</span>
        </h1>

        {/* Product Mockup */}
        <div className="animate-fade-in-up delay-150 flex justify-center mb-8" data-id="element-40">
          <img src="https://cdn.magicpatterns.com/uploads/bvwv3MUjJMZq6E9eHrLMxN/forbes_png_(1).png" alt="Mega Kit Maestría Operativa 2026 — Nexo Recursos" className="w-full max-w-md md:max-w-lg drop-shadow-2xl" data-id="element-41" />
        </div>

        {/* Product Card */}
        <div className="animate-fade-in-up delay-200 bg-gray-900/80 border border-emerald-500/30 rounded-2xl p-6 md:p-8 mb-8 relative overflow-hidden" data-id="element-42">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-600 via-emerald-400 to-emerald-600" data-id="element-43" />
          <h2 className="text-xl md:text-3xl font-bold text-white mb-3" data-id="element-44">
            MEGA KIT: MAESTRÍA OPERATIVA 2026
          </h2>
          <p className="text-base md:text-lg text-emerald-400 font-semibold mb-4" data-id="element-45">
            El sistema N°1 para dueños de PyME en Argentina — Estructura +
            Equipo + Estrategia + Ejecución + Eficiencia + Liderazgo
          </p>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-46">
            Procesos + delegación + control + estrategia listos para
            implementar. Sin consultoría. Sin cursos interminables. Sin perder
            más tiempo operando a ciegas.
          </p>
        </div>

        {/* Badges */}
        <div className="animate-fade-in-up delay-300 flex flex-wrap justify-center gap-2 md:gap-3 mb-10" data-id="element-47">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Contexto Argentina 2026', '📚 6 Tomos + 6 Bonos', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 rounded-lg bg-gray-800/80 text-gray-200 text-xs md:text-sm font-medium border border-gray-700" data-id="element-48">
              {b}
            </span>)}
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-400 flex flex-col items-center mb-16" data-id="element-49">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-10 py-5 text-lg md:text-xl font-bold text-gray-950 bg-emerald-500 hover:bg-emerald-400 rounded-xl transition-all active:scale-95" data-id="element-50">
            → QUIERO MI MEGA KIT AHORA
          </a>
          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mt-5 text-xs md:text-sm font-medium text-gray-500" data-id="element-51">
            <span data-id="element-52">🛡️ Garantía 7 días</span>
            <span className="hidden sm:inline text-gray-700" data-id="element-53">|</span>
            <span data-id="element-54">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-gray-700" data-id="element-55">|</span>
            <span data-id="element-56">💳 Mercado Pago</span>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-gray-800 bg-gray-900/60" data-id="element-57">
        <div className="max-w-5xl mx-auto px-4" data-id="element-58">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 py-8 md:py-10" data-id="element-59">
            {[{
            val: '+300',
            label: 'dueños de PyME ya lo tienen'
          }, {
            val: '6',
            label: 'Tomos completos'
          }, {
            val: '6',
            label: 'Bonos incluidos'
          }, {
            val: '4.9/5 ★',
            label: 'calificación'
          }].map((s, i) => <div key={i} className="text-center px-4" data-id="element-60">
                <div className="text-2xl md:text-4xl font-bold text-white mb-1" data-id="element-61">
                  {s.val}
                </div>
                <div className="text-[11px] md:text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-62">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}